import {SliceStatus} from '../Redux.types'
import {
  CustomApplicationBypassDataFromServer,
  CustomDomainBypassListItemFromServer,
} from 'interfaces/Policy'

export interface NotificationsResponse {
  ssl_errors: SSLErrorsNode
}

export enum SSLType {
  app = 'app',
  url = 'url',
}
export interface SSLErrorsNode {
  apps?: SSLErrorsByView[]
  urls?: SSLErrorsByView[]
  total_app_count: number
  total_url_count: number
  offset: number
}

export interface SSLErrorsByView {
  parent_label: string
  urls: SSLErrorChildURL[]
  user_ids: string[]
  total_user_count: number
}

export interface SSLErrorChildURL {
  url: string
  count: number
}

export interface NotificationParamsType {
  offset: number
  type: SSLType
  limit?: number
}

// react component types
export interface SSLErrorDetailsType {
  items: SSLErrorItemType[]
  totalAppCount: number
  totalUrlCount: number
  offset: number
  sslType?: SSLType
}

export interface SSLNotificationByView {
  items: SSLErrorItemType[]
  offset: number
}

export interface SSLErrorNotificationState {
  selectedSSLErrorView: SSLType
  byAppNotifications: SSLNotificationByView
  byUrlNotifications: SSLNotificationByView
  totalAppCount: number
  totalUrlCount: number
  status: SliceStatus
  selectedSSLErrorViewOffset: number
}

export interface AccordionProps {
  items: SSLErrorItemType[]
  hasMore: boolean
  handleChange: (updatedItems: SSLErrorItemType[]) => void
  fetchData: () => void
  isByAppViewSelected: boolean
  updateByPass: (
    bypassPayload: AddByPassType | CustomAddBypassFromNotificationsPayload,
  ) => Promise<void>
  areMultipleItemsSelected: boolean
  isUpdateBypassLoading: boolean
}

export interface SSLErrorItemType {
  processName: string
  errorCount: number
  childItems: SSLErrorChildItemType[]
  childSelection: boolean
  isSelected: boolean
  expand: boolean
  userList: string[]
  totalUserCount: number
}

export interface SSLErrorChildItemType extends SSLErrorChildURL {
  isSelected: boolean
}

export interface AccordionItemProps extends SSLErrorItemType {
  id: string
  isLast: boolean
  isByAppViewSelected: boolean
  onItemChange: (item: SSLErrorItemType) => void
  areMultipleSelected: boolean
  updateByPass: (
    bypassPayload: AddByPassType | CustomAddBypassFromNotificationsPayload,
  ) => Promise<void>
  isUpdateBypassLoading: boolean
}

export interface AddByPassType {
  applicationBypassList?: {
    Windows?: string[]
    Mac?: string[]
  }
  domainBypassList?: string[]
}

export interface CustomAddBypassFromNotificationsPayload {
  customDomainBypassList?: CustomDomainBypassListItemFromServer[]
  customApplicationBypassList?: CustomApplicationBypassDataFromServer
}

export interface SelectedItemsTypeForActionButton {
  parentItems: string[]
  childItems: string[]
}
